import { FaDownload, FaFilePdf, FaFileWord, FaUpload } from "react-icons/fa";
import "./StatementLetterSection.css";

const StatementLetterSection = ({
  register,
  errors,
  onDownloadPdf,
  onDownloadDocx,
  selectedFile,
}) => {
  const validatePdf = (files) => {
    const file = files?.[0];

    if (!file) return true;

    return (
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf") ||
      "Please upload the signed statement letter as a PDF document."
    );
  };

  return (
    <section className="statement-letter-panel" aria-labelledby="statement-letter-title">
      <div className="statement-letter-heading">
        <span className="statement-letter-kicker">Required document</span>
        <h3 id="statement-letter-title">Formal Statement of Commitment</h3>
        <p>Download the letter, sign it, then upload the signed version as a PDF.</p>
      </div>

      <div className="statement-letter-step">
        <div className="statement-step-heading">
          <span className="statement-step-number">1</span>
          <div>
            <strong>Download the statement letter</strong>
            <small>Choose the format that works best for you.</small>
          </div>
        </div>

        <div className="statement-download-grid">
          <button
            type="button"
            className="statement-download-option statement-download-option--pdf"
            onClick={onDownloadPdf}
            aria-label="Download statement letter as PDF"
          >
            <span className="statement-format-icon" aria-hidden="true">
              <FaFilePdf />
            </span>
            <span className="statement-format-copy">
              <strong>PDF</strong>
            </span>
            <FaDownload className="statement-download-icon" aria-hidden="true" />
          </button>

          <button
            type="button"
            className="statement-download-option statement-download-option--docx"
            onClick={onDownloadDocx}
            aria-label="Download statement letter as Word document"
          >
            <span className="statement-format-icon" aria-hidden="true">
              <FaFileWord />
            </span>
            <span className="statement-format-copy">
              <strong>Word</strong>
            </span>
            <FaDownload className="statement-download-icon" aria-hidden="true" />
          </button>
        </div>
      </div>

      <div className="statement-letter-step statement-letter-upload-step">
        <div className="statement-step-heading">
          <span className="statement-step-number">2</span>
          <div>
            <label htmlFor="signedDocument">
              Upload the signed letter <span className="text-danger">*</span>
            </label>
            <small>PDF document only, after the letter has been signed.</small>
          </div>
        </div>

        <label className="statement-upload-box" htmlFor="signedDocument">
          <FaUpload aria-hidden="true" />
          <span>
            <strong>{selectedFile ? selectedFile.name : "Select signed PDF"}</strong>
            <small>{selectedFile ? "PDF selected — click to replace" : "Accepted format: .pdf"}</small>
          </span>
          <input
            {...register("signedDocument", {
              required: "Please upload the signed statement letter as a PDF document.",
              validate: validatePdf,
            })}
            id="signedDocument"
            type="file"
            accept=".pdf,application/pdf"
            className="statement-file-input"
            aria-describedby="signed-document-help"
            aria-invalid={Boolean(errors.signedDocument)}
          />
        </label>
        <p id="signed-document-help" className="statement-upload-help">
          Sign the downloaded letter, then scan or export it to PDF before uploading.
        </p>

        {errors.signedDocument && (
          <div className="statement-upload-error" role="alert">
            {errors.signedDocument.message}
          </div>
        )}
      </div>
    </section>
  );
};

export default StatementLetterSection;
